import dayjs from 'dayjs';

export const today = dayjs();
export const weekBeforeToday = today.subtract(7, 'day');
export const monthBeforeToday = today.subtract(30, 'day');
export const yearBeforeToday = today.subtract(1, 'year');
export const fistDayOfCurrentMonth = today.startOf('month');
